import '../styles/Banner.css';

export default function Banner() {
  return (
    <div className='banner'>
        <h1>Chez vous, partout et ailleurs</h1>
    </div>
  )
}